import { forwardRef } from "react";
import {
  Link as RouterLink,
  NavLink as RouterNavLink,
  type LinkProps as RouterLinkProps,
} from "react-router-dom";

const LinkBehavior = forwardRef<
  HTMLAnchorElement,
  Omit<RouterLinkProps, "to"> & { href: RouterLinkProps["to"]; nav?: boolean }
>((props, ref) => {
  const { href, nav, ...other } = props;

  if (
    typeof href === "string" &&
    (href.startsWith("http") || href.startsWith("mailto"))
  ) {
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return <a ref={ref} href={href} {...other} />;
  }

  const Comp = nav ? RouterNavLink : RouterLink;
  return <Comp ref={ref} to={href} {...other} />;
});

export default LinkBehavior;
